<template>
  <div class="animated fadeIn" id="list-decomptes">
    <a v-if="(tableEntry.type_decompte === 'inval' || tableEntry.type_decompte === 'dc' || tableEntry.type_decompte === 'dcinval') && tableEntry.noSearch !== 'noSearch'"
       href="#" class="clickable mb-2 d-inline-block" @click.prevent="exportAllDecomptes">
      <i class="fa fa-file-excel-o"></i> Exporter l'intégralité des résultats au format csv
    </a>

    <v-server-table @loaded="onLoaded" ref="table" :columns="columns" :url="url" :options="options" style="overflow: hidden;">

      <div slot="created_at" slot-scope="props" class="slot-date center-date text-center">
        <span v-if="props.row.created_at" class="badge badge-success p-2">{{ formatDate(props.row.created_at) }}</span>
      </div>

      <div slot="date_ed_decompte" slot-scope="props" class="slot-date center-date text-center">
        <span v-if="props.row.date_ed_decompte" class="badge badge-success p-2">{{ formatDate(props.row.date_ed_decompte) }}</span>
      </div>

      <div slot="date_em_pai" slot-scope="props" class="slot-date center-date text-center">
        <span v-if="props.row.date_em_pai" class="badge badge-success p-2">{{ formatDate(props.row.date_em_pai) }}</span>
      </div>

      <div slot="tot_payer" slot-scope="props" class="slot-number">
        <small class="font-italic">{{ getNatureDecompte(props.row.tot_payer)}}</small><br>
        <span :style="props.row.tot_payer < 0 ? 'color:#ce0b35' : ''">
          <b>{{ formatNumber(props.row.tot_payer) }} €</b>
        </span>
      </div>

      <div slot="nom_ben_presta" slot-scope="props" class="formatted-box">
        <div v-if="props.row.nom_ben_presta">
          <b class="text-uppercase">{{ props.row.nom_ben_presta }}</b> {{ props.row.prenom_ben_presta }} <br>
          <span style="color: #2139ff; font-family: monospace;">{{ props.row.nir_pp }}</span>
        </div>
        <div v-else-if="props.row.nom_dest">
          <b class="text-uppercase">{{ props.row.nom_dest }}</b> {{ props.row.prenom_dest }} <br>
          <span style="color: #2139ff; font-family: monospace;">{{ props.row.nir_pp }}</span>
        </div>
      </div>

      <div slot="decomptePdf" slot-scope="props" class="text-center">
        <div v-if="!(props.row.type_decompte == 'dc' && props.row.tot_payer <= 0)">
          <img style="width: 18px;" class="clickable" :src="getIcon('pdf')"
               @click="download(props.row)" title="Télécharger le PDF">
        </div>
      </div>

    </v-server-table>
  </div>
</template>

<script>
import axios from 'axios';
import { getProvider } from "@/utils/auth";
import { formatDate, formatNumber, replaceDotToComma } from "@/utils/communHelper";
import { isEmpty, getFileIcon, downloadFile } from "@/utils/fileHelper";

export default {
  name: "DecomptesTable",
  props: ["tableEntry"],
  data() {
    let self = this;
    return {
      url: '',
      decomptes: [],
      columns: [
        "created_at",
        "date_ed_decompte",
        "date_em_pai",
        "id_pp_dest_reglement",
        "num_decompte",
        "numero_contrat_col",
        "nom_ben_presta",
        "rs_pm_site",
        "lib_gar",
        "tot_payer",
        "decomptePdf"
      ],
      searchData: [],
      options: {
        texts: {
          noResults: "Aucun enregistrement trouvé",
          loading: "Chargement des données...",
        },
        headings: {
          created_at: "Date \nChargement",
          date_ed_decompte: "Date \nÉdition",
          date_em_pai: "Date \nPaiement",
          id_pp_dest_reglement: "ID NSI",
          num_decompte: "N° Décompte",
          numero_contrat_col: "Contrat / Produit",
          nom_ben_presta: "Bénéficiaire / NIR",
          rs_pm_site: "Établissement",
          lib_gar: "Garantie",
          tot_payer: "Montant",
          decomptePdf: "#"
        },
        columnsClasses: {
          nom_ben_presta: 'pre-formatted sort-top',
          tot_payer: 'text-right font-weight-bold',
          decomptePdf: 'text-center',
          created_at: 'text-center',
          date_ed_decompte: 'text-center',
          date_em_pai: 'text-center',
        },
        perPage: 25,
        perPageValues: [25, 50, 100],
        sortable: ["created_at", "date_ed_decompte", "date_em_pai"],
        filterable: false,
        requestFunction: function (data) {
          if (self.tableEntry.noSearch === 'noSearch' &&
            isEmpty(self.tableEntry.num_decompte) &&
            isEmpty(self.tableEntry.nir) &&
            isEmpty(self.tableEntry.id_pp)) {
            return new Promise((resolve) => {
              resolve({ data: { data: [], count: 0 } });
            });
          }

          self.url = '/espaceBeneficiaire/decomptes/recherche_decomptes_bo';

          const params = {
            ...data,
            num_decompte: self.tableEntry.num_decompte,
            num_dossier: self.tableEntry.num_dossier,
            id_pp: self.tableEntry.id_pp,
            nir: self.tableEntry.nir,
            nom: self.tableEntry.nom,
            prenom: self.tableEntry.prenom,
            siren: self.tableEntry.siren,
            raison_sociale: self.tableEntry.raison_sociale,

            // Filtres techniques
            type_decompte: self.tableEntry.type_decompte,
            amountStatus: self.tableEntry.amountStatus, // "1", "2", "3" ou ""

            // Dates de paiement
            date_du: self.tableEntry.date_du,
            date_au: self.tableEntry.date_au,

            // DATES DE CHARGEMENT (Crucial pour ton bug de 2019)
            date_chargement_debut_decompte: self.tableEntry.date_chargement_debut_decompte,
            date_chargement_fin_decompte: self.tableEntry.date_chargement_fin_decompte,

            noSearch: self.tableEntry.noSearch,
            fromEG: self.tableEntry.fromEG
          };

          if (self.tableEntry.noSearch !== 'noSearch') {
            self.$store.commit('IS_LOADING', true);
          }

          return axios.get(self.url, { params })
            .then((response) => {
              self.$store.commit('IS_LOADING', false);
              self.decomptes = response.data.data;
              self.searchData = params;
              return response;
            })
            .catch(() => {
              self.$store.commit("IS_LOADING", false);
            });
        }
      },
      formatDate,
      formatNumber,
      isEmpty,
    };
  },
  methods: {
    onLoaded(){
      this.$store.commit("IS_LOADING", false);
    },
    getNatureDecompte(montant) {
      if (montant > 0) return 'Versement';
      if (montant < 0) return 'Débit';
      return 'Info';
    },
    getIcon(extension) {
      const images = require.context('../../../assets/images/', false, /^\.\/\S+.*\.[a-zA-Z]+$/);
      const extensionIcon = getFileIcon();
      return images('./' + extensionIcon[extension]);
    },
    download(decompte){
      this.downloadPDF(decompte.num_decompte, decompte.id, decompte.id_pp_dest_reglement, decompte.type_decompte);
    },
    downloadPDF(numDecompte, decompte_id, idpp, typeDecompte) {
      const dataPost = { idpp, typeRente: typeDecompte, provider: getProvider() };
      this.$store.commit('IS_LOADING', true);
      this.$axios.post('/espaceBeneficiaire/beneficiaires/decomptes/download/' + decompte_id, dataPost, { responseType: 'arraybuffer' })
        .then((response) => {
          this.$store.commit('IS_LOADING', false);
          downloadFile(response, 'decompte_' + numDecompte, 'pdf');
        })
        .catch(() => {
          this.$store.commit('IS_LOADING', false);
        });
    },
    exportAllDecomptes() {
      if (this.searchData && Object.keys(this.searchData).length !== 0) {
        this.$emit('export-all-decomptes-inval', {
          search_data: this.searchData,
          data: this.decomptes
        });
      }
    },
  }
};
</script>

<style scoped>
.formatted-box {
  white-space: nowrap !important;
  font-size: 0.85rem;
}
tr.VueTables__row td {
  line-height: 1.2;
  padding: 0.6rem 0.5rem !important;
  vertical-align: middle !important;
}
.center-date {
  display: block;
  width: 100%;
}
#list-decomptes .VueTables__table thead tr th {
  vertical-align: middle;
  text-align: center;
  background-color: #f8f9fa;
  font-size: 0.8rem;
  white-space: pre-line; /* Permet le retour à la ligne dans les headings */
}
</style>
